<app-filters-graph
  (getBaseFromFilter)="componentService.updateFilterConfig($event, graphID)"
  (thresholdSubj)="componentService.updateThreshold($event, graphID)"
  [eUid]="eUid"
  [configuredPreselectionId]="configuredPreselectionId"
  [graphChoicesStepEnabled]="graphChoicesStepEnabled"
  [selectedTagsUid]="selectedTagsUid"
  [showbtnExportRequest]="false">
</app-filters-graph>
@if (componentService.getTruncateState(graphID)) {
  <div class="alert alert-warning alert__truncated-data">
    {{ 'stations.graph.message.truncated_date' | translate : {truncated_date: componentService.getStartDate(graphID), end_date: componentService.getEndDate(graphID)} }}
  </div>
}

<div class="graph-n-filter-graph">
  <app-graph-echart [echartData]="componentService.getDataSubject(graphID)" [thresholdValue]="componentService.getThresholdSubject(graphID)" [isRequesting]="componentService.getGraphLoadingState(graphID)"
    [selectedTagsUid]="selectedTagsUid" (currentUnitsSubj)="componentService.updateUnits($event, graphID)">
  </app-graph-echart>
</div>
